// import { IText } from "fabric/fabric-impl";
import React from "react";

class Notes extends React.Component {

    state = {
        pje: [
            {
                name: 'My notes',
                countnote: '30',
                taskimg: [
                    { img: '/assets/images/task1.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task2.jpg' },
                ]
            },
            {
                name: 'My notes2',
                countnote: '30',
                taskimg: [
                    { img: '/assets/images/task1.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task2.jpg' },
                ]
            },
            {
                name: 'My notes2',
                countnote: '30',
                taskimg: [
                    { img: '/assets/images/task1.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task2.jpg' },
                ]
            },
            {
                name: 'My notes2',
                countnote: '30',
                taskimg: [
                    { img: '/assets/images/task1.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task2.jpg' },
                ]
            },
            {
                name: 'My notes2',
                countnote: '30',
                taskimg: [
                    { img: '/assets/images/task1.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task2.jpg' },
                ]
            },
            {
                name: 'My notes2',
                countnote: '30',
                taskimg: [
                    { img: '/assets/images/task1.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task2.jpg' },
                ]
            },
            {
                name: 'My notes2',
                countnote: '30',
                taskimg: [
                    { img: '/assets/images/task1.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task2.jpg' },
                ]
            },
            {
                name: 'My notes2',
                countnote: '30',
                taskimg: [
                    { img: '/assets/images/task1.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task3.jpg' },
                    { img: '/assets/images/task2.jpg' },
                ]
            },
        ]
    }


    componentDidMount() {
        // this.init()
        this.main.addEventListener('wheel', this.onWheel, true)
    }


    componentWillUnmount() {
        this.main.removeEventListener('wheel', this.onWheel)

    }


    onWheel = (e) => {
        // console.log(e)
        e.stopPropagation()
    }


    render() {
        return (

            <div className="dashboard-widgets">
                <div style={{}} className="d-flex justify-content-between align-items-center p-3">
                    <div className="d-flex align-content-center">
                        <p>Recentiy Notes</p>
                    </div>
                    <div className="d-flex align-content-center">
                        <button><img src="/images/creatnots.png" width={'30px'} /></button>
                    </div>
                </div>
                <div ref={el => this.main = el} className='box-shadow-widgets' style={{ minHeight: 300, height: '100%', maxHeight: '400px', overflow: 'auto' }}>

                    <div className="mb-3  " style={{ margin: ' 0 5% ' }}>
                        <div className="" style={{}}>
                            {this.state.pje.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <div className="d-flex justify-content-between align-items-center " style={{ padding: '3% 0' }}>
                                            <div>
                                                <p style={{ fontSize: 16, color: '#252525' }}>
                                                    {item.name}
                                                </p>
                                                <p style={{ fontSize: 12, color: '#dfdfdf' }}>
                                                    {item.countnote} Notes
                                                </p>
                                            </div>
                                            <div className='flexc'>

                                                {item.taskimg.map((prop, nindex) => {
                                                    return (
                                                        <div key={nindex} className='w-35' style={{ marginLeft: -15 }} >
                                                            <img className='w-100 br-50' src={prop.img} alt="" style={{ border: '1px solid #fff' }} />
                                                            {/* <div className='w-100 br-50' style={{ background: '#ee5050', border: '2px solid #fff' }} /> */}
                                                        </div>
                                                    )
                                                })}

                                            </div>
                                        </div>
                                        <div style={{ borderBottom: '1px solid #ebeaf2' }} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>


                </div>
            </div>
        )
    }
}


export default Notes;